import React, { useEffect } from "react";

const LoadJscript = () => {
  useEffect(() => {
    // Load external scripts dynamically
    const loadallScript = (src) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        document.body.appendChild(script);
      });
    };

    const loadOwlCarouselScripts = async () => {
      await loadallScript("/assets/js/jquery.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/bootstrap.bundle.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/meanmenu.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/ajaxchimp.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/form-validator.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/contact-form-script.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/owl.carousel.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/magnific-popup.min.js"); // Ensure jQuery is loaded
      await loadallScript("/assets/js/aos.js");
      await loadallScript("/assets/js/odometer.min.js");
      await loadallScript("/assets/js/appear.min.js");
      await loadallScript("/assets/js/tweenMax.min.js");
      await loadallScript("/assets/js/custom.js");     // Your custom setup
      await loadallScript("/assets/js/tutor-sidebar.js");   
    };

    loadOwlCarouselScripts();
  }, []);
  
  return (
   <>
   </>
  );
};

export default LoadJscript;